// Single source of truth for how a loyalty points balance is shown as euros.
//
// Display rule: 100 points = 10.00 EUR, i.e. 10 points = 1 EUR.
//   100 pts -> 10,00 EUR
//   129 pts -> 12,90 EUR
//   130 pts -> 13,00 EUR
//
// This is presentation only. It does not change how points are earned nor the
// backend redemption_rate used when a reward is actually spent.
export const POINTS_PER_EUR = 10;

export function pointsToCredit(points) {
  const value = Number(points);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.round((value / POINTS_PER_EUR) * 100) / 100;
}

// Euro amount available to the customer: real cashback balance when the
// restaurant runs cashback, otherwise the points converted at the rule above.
// Never falls back to the raw points count — that rendered 129 pts as 129,00 EUR.
export function availableCredit({ cashbackBalance = 0, points = 0 } = {}) {
  const cashback = Number(cashbackBalance);
  if (Number.isFinite(cashback) && cashback > 0) return Math.round(cashback * 100) / 100;
  return pointsToCredit(points);
}

export function formatCredit(amount, locale = "es-ES") {
  const value = Number(amount);
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(value) ? value : 0);
}
